module.exports = __webpack_public_path__ + "img/9788954422970.48d11562.jpg";